import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { takeUntil, finalize, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { RestService, IS_EMPTY } from 'cargo-chief-commons';

import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

import { BaseComponent } from '@shared/base/base.component';

@Component({
	selector: 'app-project-carrier-contact-dialog',
	templateUrl: './project-carrier-contact-dialog.component.html',
	styleUrls: ['./project-carrier-contact-dialog.component.scss'],
})
export class ProjectCarrierContactDialogComponent
	extends BaseComponent
	implements OnInit, OnDestroy
{
	contactForm = new FormGroup({
		contact: new FormControl(null, [this.objectValidator.bind(this)]),
	});

	loadingContactsList: boolean = false;
	contactsList: any[] = [];
	filteredOptions: Observable<any[]>;

	constructor(
		public dialogRef: MatDialogRef<ProjectCarrierContactDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService
	) {
		super();
		if (this.data?.carrier?.carrierId) {
			this.getCarrierContacts();
		}
	}

	ngOnInit() {}

	getCarrierContacts() {
		this.loadingContactsList = true;
		const contactsUrl = this.urlService.contactsUrl(this.data?.carrier.carrierId);
		this.restService
			.GET(contactsUrl)
			.pipe(
				takeUntil(this.isDestroyed$),
				finalize(() => {
					this.loadingContactsList = false;
				})
			)
			.subscribe({
				next: (result) => {
					this.contactsList = result.data;
					this.filteredOptions = this.contactForm.get('contact')!.valueChanges.pipe(
						startWith(''),
						map((value) => this._filter(value || ''))
					);
				},
				error: (error) => {
					this.utilService.showSnackbar(
						'Cannot fetch contact list.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
				},
			});
	}

	_filter(value: string): string[] {
		const filterValue = typeof value === 'string' && value ? value.toLowerCase() : '';
		if (IS_EMPTY(filterValue)) {
			return this.contactsList;
		}

		return this.contactsList.filter(
			(option) =>
				(option?.firstName?.toLowerCase() || '').includes(filterValue) ||
				(option?.lastName?.toLowerCase() || '').includes(filterValue)
		);
	}

	objectValidator(control: AbstractControl) {
		const value = control.value;
		if (
			typeof value === 'object' &&
			value !== null &&
			this.contactsList.some((f) => f.id === value.id)
		) {
			return null;
		}
		return { invalidSelection: true };
	}

	displayContact(contact: any): string {
		return contact ? `${contact.firstName || ''} ${contact.lastName}` : '';
	}

	submitContact() {
		this.closeDialog(this.contactForm.value.contact);
	}

	addNewContact() {
		this.closeDialog({ addContact: true });
	}

	closeDialog(data: any = null): void {
		this.dialogRef.close(data);
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}
}
